import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestLotterySetting',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            showPop: false,
            currentSelectedType:null,
            result: [],
            showRepeatPicker:false,
            columns: [{text:'可以',type:'1'},{text:'不可以',type: '0'}],
            currentType:null,
            currentSubIndex:0,
            //是否可以重复抽奖，1可以，0否
            repeat:null,
            //中奖人数
            num:null,
            ignoreList:this.$route.params.ignoreList || [],
            ignoreIdList:[],
            ignoreNameList:[],

        }
    },
    beforeRouteEnter (to, from, next) {
        console.log(from.params.ignoreList)
        next(vm => {
            if(from.name === 'PlayerIgnoreList'){
                vm.ignoreList = from.params.ignoreList
            }
        })
    },
    watch: {
        ignoreList() {
            this.ignoreIdList = []
            this.ignoreNameList = []
            for (let i = 0; i < this.ignoreList.length; i++) {
                this.ignoreIdList.push(this.ignoreList[i].playerId)
                this.ignoreNameList.push(this.ignoreList[i].playerName)
            }
        }
    },
    methods: {

        toHistory(){
            this.$router.push({
                name: 'MyContestLotteryHistory',
                params: {
                    contestId: this.contestId
                }
            })

        },
        toIgnorePage(){
            this.$router.push({
                name: 'PlayerIgnoreList',
                params: {
                    contestId: this.contestId,
                    ignoreList:this.ignoreList
                }
            })
        },

        async startLottery(){
            this.$toast.loading()
            try {
                // eslint-disable-next-line no-unused-vars
                this.result = null;
                let result = await contestApi.startLottery(this.contestId,this.num,this.ignoreIdList.toString(),this.repeat)
                this.result = result;
                this.$toast.clear()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        onRepeatSelected(){
            this.$refs.repeatPicker.confirm();
        },
        onConfirm(value){
            this.repeat = value.type;
            this.showRepeatPicker = false
        },

    }
}
